import React from "react";
import {useState, useEffect } from 'react';

const LanguageContext = React.createContext();

const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('language') || 'uk'; 
  });

  useEffect(() => {
    localStorage.setItem('language', language);
  }, [language]);

  const translations = {
    en: require('./json/en.json'),
    uk: require('./json/uk.json'),
  };

  const translate = (key) => {
    const keys = key.split('.');
    return keys.reduce((acc, curr) => (acc && acc[curr] ? acc[curr] : key), translations[language]);
  };
  

  return (
    <LanguageContext.Provider value={{ language, setLanguage, translate }}>
      {children}
    </LanguageContext.Provider>
  );
};

export { LanguageProvider, LanguageContext };
